module.exports = __webpack_public_path__ + "static/img/kf.f6b4a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/kf.png
// module id = qOL0
// module chunks = 66